// 之前的state
let repairConf = {};
let flowConf = {};
let signClass = [];
let sighQuery = {};
// 智能门锁设备管理=》选择楼栋页面显示基础设置按钮
let IsShowBaseSetBtn = false;
let SchoolFlatId = '';
// ================服务大厅2.0定义====================
// 页面背景颜色
const BACKGROUND_COLORS = [
    '#F5F7FA',
    '#E2F7DD',
    '#DDEEFF',
    '#FFF3E0',
    '#FEE4F0',
    '#DCF7F8',
    '#EAEBFF',
    '#FFEAE0',
];
// 当前要修改的类型
let CurrentModifyType = 0; // 组件类型 0-页面设置 1-轮播图 2-主功能按钮 3-功能模块
// 当前增加或修改的数据
let CurrentModifyData = {};
// 页面基本信息
let PageBasicData = {
    id: '',
    title: '',
    color: 0,
    support: true,
    supportDisplay: 0,
    schoolId: '',
};
// 组件列表
let PageModuleList = [];
// 选择icon及颜色
const CHOOSE_ICON_COLORS = [
    {
        color: '#3EC81B',
        bgColor: '#D0F7C6',
        keyPrefix: 'green',
    },
    {
        color: '#1890FF',
        bgColor: '#C8E4FE',
        keyPrefix: 'blue',
    },
    {
        color: '#FFAF32',
        bgColor: '#FCE9CA',
        keyPrefix: 'yellow',
    },
    {
        color: '#F8489B',
        bgColor: '#FED1E6',
        keyPrefix: 'red',
    },
    {
        color: '#13C6D3',
        bgColor: '#B4EDF1',
        keyPrefix: 'cyan',
    },
    {
        color: '#747BFF',
        bgColor: '#CCCFFF',
        keyPrefix: 'purple',
    },
    {
        color: '#FF7132',
        bgColor: '#FBD8C8',
        keyPrefix: 'orange',
    },
];
// 小的功能图标列表
const APPLICATION_ICONS = [
    'biyelixiao',
    'baodaodengji',
    'chaqin',
    'fuwujiandu',
    'gerenzhongxin',
    'liucheng-gerenzhongxin',
    'dingcan',
    'haibaozhangtieshenqing',
    'dianhuaben',
    'jiaqiliuxiaodengji',
    'changguanyuyue',
    'dianpuweixinbangding',
    'gongyudafen',
    'shenghuochaoshi',
    'tiaosushenqing',
    'qingjia',
    'tuisushenqing',
    'weixiugong',
    'liuyanban',
    'qiandao',
    'wodesushe',
    'peisongyuanweixinduan',
    'shuidianjiaofei',
    'xueshengjiachangbangding',
    'tongchengtongxue',
    'shiwuzhaoling',
    'xinwengonggao',
    'xueshengxuanfang',
    'waizhushenqing',
    'liucheng-wodeshenqing',
    'tushu',
    'zhoumoquxiang',
    'yingxinzhuanti',
    'yidongpaigong',
    'huodongguanli',
    'wodeshenpi',
    'xueshengjifen',
    'shangchengdingdan',
    'xueshengxinxichaxun',
    'zhinengbaoxiu',
    'wuzijieyong',
    'renlianguanli',
    'Ematong',
    'yuechaxun',
    'kagaimi',
    'zhangdanchaxun',
    'chongzhi',
    'guashi',
];

// 是否有管理权限
let IsAdmin = false;

export default {
    repairConf,
    flowConf,
    signClass,
    sighQuery,
    IsShowBaseSetBtn,
    SchoolFlatId,
    BACKGROUND_COLORS,
    CHOOSE_ICON_COLORS,
    APPLICATION_ICONS,
    CurrentModifyType,
    CurrentModifyData,
    PageBasicData,
    PageModuleList,
    IsAdmin,
};
